<template>
    <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
            Bundle Image
        </label>
        <ImageUpload
            :selected-image="asset"
            v-model="asset"
            storage-api-path="/admin/content/bundles/images"
        />
        <input type="hidden" :name="inputName" :value="asset" />
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import ImageUpload from "@/components/_elements/images/ImageUpload.vue";

const props = defineProps<{
    initialAsset?: string;
    inputName?: string;
}>();
const asset = ref(props.initialAsset ?? "");
</script>
